import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/supplier_appCommonService";

const initialState = {
  quality_check: {
    data: [],
    status: false,
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
    grnNumber: localStorage.getItem("qc_grnNumber") || "",
  },
  quality_check_detail: {
    data: {},
    status: false,
    qualityCheckNr: localStorage.getItem("qc_qualityCheckNr") || "",
  },
};

const qualityCheckSlice = createSlice({
  name: "qualityCheck",
  initialState,
  reducers: {
    addQualityCheckGRNNumber: (state, action) => {
      state.quality_check.grnNumber = action.payload;
      localStorage.setItem("qc_grnNumber", action.payload);
    },
    addQualityCheckNr: (state, action) => {
      state.quality_check_detail.qualityCheckNr = action.payload;
      localStorage.setItem("qc_qualityCheckNr", action.payload);
    },
    clearQualityCheckData: (state) => {
      state.quality_check.data = [];
      state.quality_check.grnNumber = "";
      state.quality_check_detail.data = {};
      state.quality_check_detail.qualityCheckNr = "";
      localStorage.removeItem("qc_grnNumber");
      localStorage.removeItem("qc_qualityCheckNr");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQualityCheckList.pending, (state) => {
        state.quality_check.status = true;
      })
      .addCase(getQualityCheckList.fulfilled, (state, action) => {
        state.quality_check.status = false;
        state.quality_check.data = action.payload?.data || [];
        state.quality_check.pagination = {
          page: action.payload?.page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
        };
      })
      .addCase(getQualityCheckList.rejected, (state) => {
        state.quality_check.status = false;
      })

      .addCase(getQualityCheckDetail.pending, (state) => {
        state.quality_check_detail.status = true;
      })
      .addCase(getQualityCheckDetail.fulfilled, (state, action) => {
        state.quality_check_detail.status = false;
        state.quality_check_detail.data = action.payload?.data || {};
      })
      .addCase(getQualityCheckDetail.rejected, (state) => {
        state.quality_check_detail.status = false;
      });
  },
});

export const { addQualityCheckGRNNumber, addQualityCheckNr, clearQualityCheckData } =
  qualityCheckSlice.actions;
export default qualityCheckSlice.reducer;

export const getQualityCheckList = createAsyncThunk(
  "qualityCheck/getQualityCheckList",
  async (param) => {
    const response = await ItemService.getQualityCheckList(param);
    return response;
  }
);

export const getQualityCheckDetail = createAsyncThunk(
  "qualityCheck/getQualityCheckDetail",
  async (param) => {
    const response = await ItemService.getQualityCheckDetail(param);
    return response;
  }
);
